<template>
  <div class="g-bd">
    <div class="con-tag news-tag">
      <h2>“乡村振兴”专题课程清单</h2>
    </div>
    <div class="con-body news-body">
        <div class="rural-body">
            <div class="details">
                <p> 百年辉煌，肇始于农。中国现代化离不开农业农村现代化，离不开中国共产党的坚强领导。江苏省教育厅为民办实事，在建党100周年来临之际，策划组织了“助力乡村振兴，千门优课下乡”大型公益教育行动。南京大学、南京农业大学等百所高校积极响应，数千名专家学者，精心制作了一千余门网络微课，2021年6月21日全面上线，全部免费向公众开放。乡村振兴最关键的是人才、科技需求，“千门优课”汇聚了江苏最优质的“省级高校在线开放课程”资源，设置了涵盖乡村党建和治理、现代种植养殖业、农产品加工贸易、乡村教育和健康等系统的课程模块，供广大农民和农村工作者免费在线学习，足不出户读懂政策、掌握技术、提升素质、提高品味……“千门优课”平台将进一步探索促进终身学习的长效机制，实施学习效果测试、课程培训证书申领、学分累计等措施，逐步将平台建设成为面向农业农村的文化传播、技能培训、科学普及的重要阵地，持续为乡村的产业、人才、文化、生态和组织振兴提供不竭的教育动能。</p>
            </div>
            <ul class="btnList f-clearfix">
                <li  v-for="(item,i) in buttonList" :key="i" :class="titleNmae == item.value?'checkLi':''" @click="changeList(item.value)">{{item.value}}</li>
            </ul>
            <div>
                <el-table :data="listTable" v-loading="loading">
                    <el-table-column prop="num" label="序号" width="120">
                    </el-table-column>
                    <el-table-column prop="school" label="高校名称"></el-table-column>
                    <el-table-column prop="teacher" label="主讲教师"></el-table-column>
                    <el-table-column prop="title" label="课程名称"  width="320"></el-table-column>
                    <!-- <el-table-column prop="duration" label="课程时长（min）"></el-table-column> -->
                    <el-table-column prop="exam" label="是否提供考试" width="120">
                        <!-- <template slot-scope="scope">{{["否","是"][scope.row.exam]}}</template> -->
                    </el-table-column>
                </el-table>
          </div>
          <div class="m-pagination-wrapper">
                <el-pagination
                  class="m-pagination"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[40, 80, 120,160]"
              :current-page.sync="listPage.pageNo"
              :page-size="listPage.pageSize"
              :total="listPage.total"
            ></el-pagination>
            </div>
            <div class="details">
                <p> 乡村振兴课程还可为各位学习者提供证书，学习者在完成相应考试环节后可获得证书，具体操作详见“<a href="http://www.jsmooc.com.cn/news/newsDetail?id=1405820998825865218" target="_blank">乡村振兴考试及获取证书说明</a>”。<br>网址：<a href="http://kecheng.jsou.cn/jxpt-web/country/toLogin" target="_blank">http://kecheng.jsou.cn/jxpt-web/country/toLogin</a>
                </p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        buttonList:[
            {value:"乡村党建",type:1},
            {value:"三农政策",type:2},
            {value:"科学种地",type:3},
            {value:"养殖天地",type:4},
            {value:"农产加工",type:5},
            {value:"农产贸易",type:6},
            {value:"智慧农业",type:7},
            {value:"乡村教育",type:8},
            {value:"健康生活",type:9},
            {value:"美丽乡村",type:10},
        ],
        titleNmae:"乡村党建",
        listPage: {
            pageSize: 40,
            total: 0,
            pageNo: 1,
        },
        loading:false,
        listTable:[]
    };
  },
  mounted() {
      this.getList();
  },
  methods: {
    handleSizeChange(val) {
      this.listPage.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listPage.pageNo = val;
      this.getList();
    },
    changeList(val){
        this.titleNmae = val;
        this.listPage.pageSize = 40,
        this.listPage.pageNo = 1,
        this.getList();
    },
    getList(){
        let par = {
        pageSize: this.listPage.pageSize,
        currentPage: this.listPage.pageNo,
        type: this.titleNmae,
      };
      this.$http
        .post("/api/manage/rural/getList", par)
        .then((res) => {
          this.listPage.pageNo = res.data.current;
          this.listPage.total = res.data.total;
          this.listTable = res.data.records;
          this.loading = false;
        })
        .catch((msg) => {});
    }
  },
};
</script>
<style lang="scss">
.rural-body{
    background: #fff;
    border-radius: 8px;
    padding: 40px 30px;
    .btnList{
        li{
            float: left;
            width: 172px;
            text-align: center;
            line-height: 34px;
            border: solid 1px #F6F6F6;
            background: #F6F6F6;
            margin-right: 30px;
            margin-bottom: 15px;
            cursor: pointer;
            color: #333;
            border-radius: 4px;
        }
        :hover{
            border: solid 1px #3685FDFF;
            background: #3685FDFF;
            color: #fff;
        }
        .checkLi{
            border: solid 1px #3685FDFF;
            background: #3685FDFF;
            color: #fff;
        }
        :nth-of-type(5n){
            margin-right: 0;
        }
    }
    .details{
        padding:15px 30px;
        background: #FFF3D9;
        margin-bottom: 40px;
        color: #333;
        border-radius: 4px;
        p{
            text-indent: 2em;
            line-height: 20px;
            font-size: 14px;
            span{
                font-size: 18px;
                font-weight: bold;
            }
            a{
                color: #3685FDFF;
            }
        }
    }
}
</style>
